import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { getPointsRules, getRewards } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const CrewPoints = () => {
  const { user } = useAuth();
  const [rewards, setRewards] = useState([]);
  const [r, setR] = useState({ signup: 25, vote: 5, share: 10, share_daily_cap: 30, per_dollar: 1 });
  useEffect(() => { getRewards().then(setRewards).catch(() => {}); getPointsRules().then(setR).catch(() => {}); }, []);
  const earn = [["Create an account", `+${r.signup}`], ["Vote in Sus of the Month", `+${r.vote} each`], ["Share a design or product", `+${r.share} (${r.share_daily_cap}/day max)`], ["Shop", `${r.per_dollar} pt per C$1`]];
  return (
    <section className="my-20 grid gap-6 lg:grid-cols-12" aria-labelledby="points-title" data-testid="crew-points-section">
      <div className="rounded-[24px] bg-lime p-8 lg:col-span-5">
        <h2 id="points-title" className="display text-6xl">Crew Points</h2>
        <p className="font-a mt-4 text-[17px]">Log in, do sus things, get points. Trade them for discounts and crew-only stickers.</p>
        <ul className="mt-6 divide-y divide-ink/20">{earn.map(([a, b]) => <li key={a} className="flex justify-between py-3"><span>{a}</span><b>{b}</b></li>)}</ul>
        <Link to="/account" className="btn btn-ink mt-6" data-testid="crew-points-cta">{user ? `You have ${user.points} pts` : "Create an account"} <ArrowRight size={16} /></Link>
      </div>
      <ul className="grid gap-4 sm:grid-cols-3 lg:col-span-7">{rewards.map((r, i) => (
        <li key={r.id} className={`flex flex-col justify-between rounded-[24px] border-[1.5px] border-ink p-6 ${["bg-pink", "bg-sky", "bg-cloud"][i % 3]}`} data-testid={`crew-reward-${i}`}>
          <p className="display text-4xl">{r.name}</p><p className="label mt-6 font-bold">{r.cost} pts</p>
        </li>))}</ul>
    </section>
  );
};
